import React from 'react'
import { connect } from 'react-redux'
import { reduxForm, formValueSelector } from 'redux-form'
import PropTypes from 'prop-types'
import { isFetching } from 'utils/redux/fetching'
import { fetchSettings, updateSettings } from 'redux/actions/actions'
import ViewPersonal from '../components/ViewPersonal'
import Loader from 'components/Loader'

class SettingsPersonal extends React.Component {

	componentWillMount() {
		const { dispatch } = this.props
		dispatch(fetchSettings())
	}

	render () {
		if (this.props.isFetching) return <Loader />

		return <ViewPersonal {...this.props} />
	}
}

const mapDispatchToProps = dispatch => {
	return {
		dispatch,
		onSubmit: data => dispatch(updateSettings(data))
	}
}

const mapStateToProps = state => {

	if (isFetching([state.settings])) return { isFetching: true }

	const reviewedSurveyInfo = state.settings.reviewedSurveyInfo

	const selector = formValueSelector('settings-personal')
	const values = selector(state, 'gender', 'age', 'city', 'state', 'isMarried', 'hasChildren', 'ethnicity', 'religion', 'politicalAffiliation')
	const valuesArr = []
	Object.keys(values).forEach((key) => (values[key]) && valuesArr.push({ [key]: values[key] }))

	return {
		isBtnDisabled: !valuesArr.length,
		initialValues: {
			gender: reviewedSurveyInfo.includes('gender'),
			age: reviewedSurveyInfo.includes('age'),
			city: reviewedSurveyInfo.includes('city'),
			state: reviewedSurveyInfo.includes('state'),
			isMarried: reviewedSurveyInfo.includes('isMarried'),
			hasChildren: reviewedSurveyInfo.includes('hasChildren'),
			ethnicity: reviewedSurveyInfo.includes('ethnicity'),
			religion: reviewedSurveyInfo.includes('religion'),
			politicalAffiliation: reviewedSurveyInfo.includes('politicalAffiliation')
		}
	}
}

SettingsPersonal.propTypes = {
	dispatch: PropTypes.func,
	isFetching: PropTypes.bool
}

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
	form: 'settings-personal',
})(SettingsPersonal))



// WEBPACK FOOTER //
// ./src/routes/Settings/containers/SettingsPersonal.js